import React, { Fragment, useState, useEffect } from 'react';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Delete from '@material-ui/icons/Delete';
import Keyboard from '@material-ui/icons/Keyboard';
import Transcription from './Transcription';

const AudioFileAdmisionActions = ({ data, refresh,callbackTranscription,formats, dataPatient }) => {

  useEffect(() => {
    console.log("DATACOMINGaudio",dataPatient)
  }, []);

  const [openTranscription, setOpenTranscription] = useState(false);

  const deleteAudioFileAdmision = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-audios/delete', {
      method: 'DELETE',
      headers: {
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id_grabacion: data.data.original.id_grabacion })
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        refresh();
      }
    }).catch(error => {
      console.log(error);
    });
  }

  const TranscriptionModal = () => 
  {
    return (<Transcription
      dataPatient={dataPatient}
      data={data.data.original}
      transcriptionOpen={openTranscription}
      closeTranscription={() => setOpenTranscription(false)}
      callbackTranscription={callbackTranscription}
      formats={formats}
    />)
  }

  return (<Fragment>
    <td role="cell" style={{padding: 0, margin: 0}}>
      <Tooltip title="Realizar Transcripción">
        <IconButton aria-label="unable" style={{ padding: 2, marginTop: 10 }}
          onClick={() => {
            setOpenTranscription(true);
          }}>
          <Keyboard
          />
        </IconButton>
      </Tooltip>
    </td>
    <TranscriptionModal />
  </Fragment>)
}

export default AudioFileAdmisionActions;